import { jsx as o } from "react/jsx-runtime";
import { useFormContext as v, useForm as R, FormProvider as f } from "react-hook-form";
import D, { createElement as L } from "react";
import { W as k } from "./word-divider.CVhHpXUP.js";
import { useI18n as b } from "next-localization";
import { T as w } from "./Typeahead.RUczeL1X.js";
import { FORM_VALIDATION_REGEX as A } from "../utils/forms/index.js";
import { u as I } from "./use-suggest-location-name.bFv45epg.js";
import { NeuSelect as T, NeuButton as O } from "@hcahealthcaredpx/neutron-react";
import { U as V } from "./use-my-location-input.CZSDQ8rr.js";
import { u as _ } from "./use-suggest-taxonomy.C5UfMntA.js";
var a = /* @__PURE__ */ ((e) => (e.FacilityNameSearch = "facilityNameSearch", e.LocationSearch = "address", e.FacilityTypeSelect = "facilityTypeSelect", e.LocationNameSelect = "locationNameSelect", e.SpecialtySelect = "specialtySelect", e.RadiusSelect = "radius", e.SubmitButton = "submitButton", e.Divider = "divider", e))(a || {});
const {
  FacilityNameSearch: B,
  LocationSearch: x
  // FacilityTypeSelect,
  // SpecialtySelect,
  // RadiusSelect,
  // SubmitButton,
  // Divider,
} = a, U = [
  {
    label: "20 miles",
    value: "20"
  },
  {
    label: "50 miles",
    value: "50"
  },
  {
    label: "100 miles",
    value: "100"
  }
], N = "col-12 py-3", $ = [
  B,
  //   Divider,
  x
  //   FacilityTypeSelect,
  //   SpecialtySelect,
  //   RadiusSelect,
  //   SubmitButton,
], g = ({ placeholder: e, className: t }) => {
  const { t: c } = b(), { register: i } = v(), { FacilityNameSearch: l } = a, r = i(l, {
    pattern: {
      value: A,
      message: c("Search.Errors.InvalidSpecialCharacters")
    }
  }), { typeaheadItems: u, setLocationName: s } = I();
  return /* @__PURE__ */ o("div", { className: t ?? N, children: /* @__PURE__ */ o(
    w,
    {
      ...r,
      items: u ?? [],
      label: c("Locations.Search.Form.SearchByFacilityName"),
      placeholder: e ?? c("Locations.Search.Form.EnterFacilityName"),
      popperStrategy: "fixed",
      onTypeaheadKeyPress: (n) => {
        s(n.length >= 3 ? n : null);
      }
    }
  ) });
}, M = ({
  className: e,
  facilityOptions: t = [],
  useMultiSelect: c = !1,
  preSelectedFacilityOptions: i
}) => {
  const l = v(), { watch: r, setValue: u } = l, { FacilityTypeSelect: s, FacilityNameSearch: n } = a, { t: m } = b(), h = !((t == null ? void 0 : t.find((S) => S.value === "all" || S.value === "")) !== void 0) && !c ? [
    {
      value: "all",
      label: m("Locations.Search.Form.Filter.FacilityShowAll")
    },
    ...t
  ] : [...t], [, y] = D.useState(
    i ?? []
  );
  return c ? /* @__PURE__ */ o("div", { className: e ?? N, children: /* @__PURE__ */ o(
    T,
    {
      clear: !0,
      kind: "multiple",
      items: h,
      label: m("Locations.Search.Form.Filter.FacilityTypeLabel"),
      onNeuChange: (S) => {
        const F = S.value;
        y(F === null ? void 0 : S.value), u(s, F === null ? void 0 : S.value);
      },
      disabled: !!r(n)
    }
  ) }) : /* @__PURE__ */ o("div", { className: e ?? N, children: /* @__PURE__ */ o(
    T,
    {
      clear: !0,
      items: h,
      label: m("Locations.Search.Form.Filter.FacilityTypeLabel"),
      onNeuChange: (S) => {
        const F = S.value;
        u(s, F);
      },
      disabled: !!r(n)
    }
  ) });
}, P = ({
  locationOptions: e = [],
  onSelect: t,
  className: c
}) => {
  const i = v(), { watch: l, setValue: r } = i, { LocationNameSelect: u, LocationSearch: s } = a, { t: n } = b();
  return /* @__PURE__ */ o("div", { className: c ?? N, children: /* @__PURE__ */ o(
    T,
    {
      clear: !0,
      items: e,
      label: n("Locations.Facilities.SelectFacility"),
      onNeuChange: (m) => {
        const d = m.value;
        r(u, d), t == null || t(d);
      },
      disabled: !!l(s)
    }
  ) });
}, j = ({ placeholder: e, id: t, className: c }) => {
  const i = v(), { watch: l } = i, { FacilityNameSearch: r, LocationSearch: u } = a, { t: s } = b();
  return /* @__PURE__ */ o("div", { className: c ?? N, children: /* @__PURE__ */ o(
    V,
    {
      disabled: !!l(r),
      id: t ?? u,
      label: s("Search.EnterLocation"),
      placeholder: e ?? s("Locations.Search.Form.EnterLocationPlaceholder"),
      popperStrategy: "fixed"
    }
  ) });
}, E = ({ className: e, popperStrategy: t }) => {
  const c = v(), { watch: i, setValue: l } = c, { FacilityNameSearch: r, LocationSearch: u, RadiusSelect: s } = a, { t: n } = b();
  return /* @__PURE__ */ o("div", { className: e ?? N, children: /* @__PURE__ */ o(
    T,
    {
      clear: !0,
      items: U,
      label: n("Search.Distance"),
      onNeuChange: (m) => {
        const d = m.value;
        l(s, d);
      },
      disabled: !!i(r) || !i(u),
      popperStrategy: t
    }
  ) });
}, K = ({ className: e }) => {
  var m, d;
  const t = v(), { watch: c, setValue: i } = t, { SpecialtySelect: l, FacilityNameSearch: r } = a, { t: u } = b(), { data: s } = _({}), n = s && ((m = s == null ? void 0 : s.data) != null && m.length) ? (d = s.data) == null ? void 0 : d.flatMap((h) => {
    const y = [];
    return h.specialty && y.push({
      value: h.specialty,
      label: h.specialty
    }), h.subSpecialties.length && y.push(
      ...h.subSpecialties.map((S) => ({
        value: S,
        label: S
      }))
    ), y;
  }) : [];
  return /* @__PURE__ */ o("div", { className: e ?? N, children: /* @__PURE__ */ o(
    T,
    {
      clear: !0,
      filter: !0,
      items: n,
      label: u("Locations.Search.Form.Filter.SpecialtyLabel"),
      onNeuChange: (h) => {
        const y = h.value;
        i(l, y);
      },
      disabled: !!c(r)
    }
  ) });
}, W = ({
  className: e,
  buttonClassName: t,
  buttonText: c,
  neuButtonProps: i
}) => {
  const { t: l } = b();
  return /* @__PURE__ */ o("div", { className: e ?? N, children: /* @__PURE__ */ o(O, { className: t, type: "submit", ...i, children: c ?? l("Common.Search") }) });
};
function ce(e) {
  const t = { ...e };
  return Object.keys(t).forEach((c) => {
    t[c] === "" && (t[c] = void 0);
  }), t;
}
const p = (e, t) => `${e}-${t}`, G = (e, t) => {
  if (!e)
    return null;
  const i = ((e == null ? void 0 : e.formFieldOrder) ?? $).map((l, r) => {
    switch (l) {
      case a.FacilityNameSearch:
        return /* @__PURE__ */ L(
          g,
          {
            isLoading: t,
            ...e[l],
            key: p(a.FacilityNameSearch, r)
          }
        );
      case a.LocationSearch:
        return /* @__PURE__ */ L(
          j,
          {
            isLoading: t,
            ...e[l],
            key: p(a.LocationSearch, r)
          }
        );
      case a.FacilityTypeSelect:
        return /* @__PURE__ */ L(
          M,
          {
            isLoading: t,
            ...e[l],
            key: p(a.FacilityTypeSelect, r)
          }
        );
      case a.LocationNameSelect:
        return /* @__PURE__ */ L(
          P,
          {
            isLoading: t,
            ...e[l],
            key: p(a.LocationNameSelect, r)
          }
        );
      case a.SpecialtySelect:
        return /* @__PURE__ */ L(
          K,
          {
            isLoading: t,
            ...e[l],
            key: p(a.SpecialtySelect, r)
          }
        );
      case a.RadiusSelect:
        return /* @__PURE__ */ L(
          E,
          {
            ...e[l],
            key: p(a.RadiusSelect, r)
          }
        );
      case a.SubmitButton:
        return /* @__PURE__ */ L(
          W,
          {
            isLoading: t,
            ...e[l],
            key: p(a.SubmitButton, r)
          }
        );
      case a.Divider:
        return /* @__PURE__ */ o(k, {}, p(a.Divider, r));
      default:
        return null;
    }
  });
  return i.length > 0 ? i : null;
}, le = ({
  config: e,
  isLoading: t,
  locationSearchFormSubmit: c,
  ...i
}) => {
  const r = ((e == null ? void 0 : e.formFieldOrder) ?? []).reduce((n, m) => {
    var d, h, y, S, F, C;
    switch (m) {
      case a.FacilityNameSearch:
        n[a.FacilityNameSearch] = ((h = (d = e[a.FacilityNameSearch]) == null ? void 0 : d.defaultValue) == null ? void 0 : h.toString()) ?? "";
        break;
      case a.LocationSearch:
        n[a.LocationSearch] = ((S = (y = e[a.LocationSearch]) == null ? void 0 : y.defaultValue) == null ? void 0 : S.toString()) ?? "";
        break;
      case a.RadiusSelect:
        n[a.RadiusSelect] = ((C = (F = e[a.RadiusSelect]) == null ? void 0 : F.defaultValue) == null ? void 0 : C.toString()) ?? "";
        break;
    }
    return n;
  }, {}), u = R({
    defaultValues: r
  }), s = (n) => c && c(n);
  return /* @__PURE__ */ o(f, { ...u, children: /* @__PURE__ */ o(
    "form",
    {
      ...i,
      onSubmit: u.handleSubmit(s),
      className: i.className,
      children: e && G(e, t)
    }
  ) });
};
export {
  le as L,
  a,
  ce as c
};
